import { useSyncExternalStore } from "react";

const subscribe = (callback: () => void) => {
  document.addEventListener("visibilitychange", callback);

  return () => {
    document.removeEventListener("visibilitychange", callback);
  };
};

const getSnapshot = () => {
  const isVisible = document.visibilityState === "visible";
  return isVisible;
};

const getServerSnapshot = () => false;

export default function useWindowFocus(): boolean {
  const focused = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  );
  return focused;
}
